/**
 * Price Check Counter Service
 *
 * Lifetime counter for free-tier Price Check usage.
 * Stored at users/{uid}.priceChecksUsed.
 * Incremented on every successful save. NEVER decremented.
 * Deleting a verdict does NOT restore a check.
 */

import { doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '@/firebase/config';

export async function incrementPriceCheckCount(uid: string): Promise<void> {
  if (!uid) return;
  try {
    await updateDoc(doc(db, 'users', uid), {
      priceChecksUsed: increment(1),
    });
  } catch (err) {
    // Best-effort: never throw, save flow must not be blocked
    console.error('[priceCheckCounter] Failed to increment:', err);
  }
}
